import React from "react";
import { useNavigate } from "react-router-dom";
import helper from "services/helper";

const LuckydrawItem = ({ item = {} }) => {
  const navigate = useNavigate();

  // Calculate availability
  const isDisabled = item.available >= item.people;
  const soldoutClass = isDisabled ? " soldout" : "";

  // Handle click navigation
  const handleClick = () => {
    if (!isDisabled) {
      navigate(`/luckydraw-details?id=${item.id}`);
    }
  };

  // Format display values
  const formattedPoints = helper.FN.toNumberWithCommas(item.pointToLuckyDraw);
  const formattedTotalTime = helper.FN.toNumberWithCommas(item.totalTime);
  const formattedDate = helper.TIME.toShortDateNormalTH(item.toDate);

  return (
    <a
      style={helper.STYLE.aDisable(isDisabled)}
      onClick={handleClick}
      className={soldoutClass}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          handleClick();
        }
      }}
    >
      <div className="bPic" style={{ backgroundImage: `url(${item.img})` }} aria-label={`รูปภาพ ${item.name}`} />

      <div className="bDetails">
        <div className="tTitle">{item.name}</div>
        <div className="tDes">{item.description}</div>
        <div className="tDate">
          <span>ลุ้นได้ถึงวันที่: </span>
          {formattedDate}
        </div>
        <div className="bPointQuota">
          <div className="bPoint">
            <span>{formattedPoints}</span>
          </div>
          <div className="tQuota">
            จำนวนลุ้น (สิทธิ์)
            <span>{formattedTotalTime}</span>
          </div>
        </div>
      </div>
    </a>
  );
};

export default LuckydrawItem;
